/* ===== Bloquear el scroll de la página cuando el carrito está abierto ===== */
document.addEventListener('DOMContentLoaded', function () {
  var scrollY = 0;
  $(document.body).on('drawer.open', function () {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll';
  });
  $(document.body).on('drawer.close', function () {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflowY = '';
    window.scrollTo(0, scrollY);
  });
});

/* ===== Buscador en móvil: barra bajo el encabezado ===== */
document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('.nkoda-mobile-search-bar');
  var header = document.querySelector('.header-mobile .header-top-mobile');

  function positionBar() {
    if (bar && header) {
      bar.style.top = header.getBoundingClientRect().bottom + 'px';
    }
  }

  document.querySelectorAll('.js-header-search-mobile-toggle').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      positionBar();
      document.body.classList.toggle('modal-search--open');
      if (document.body.classList.contains('modal-search--open')) {
        var input = bar.querySelector('.nkoda-mobile-search-input');
        if (input) {
          setTimeout(function () { input.focus(); }, 100);
        }
      }
    });
  });

  window.addEventListener('resize', positionBar);
});

/* ===== Carrito lateral: la lista empieza justo debajo de la cabecera ===== */
(function () {
  function init() {
    var header = document.querySelector('.js-drawer .drawer__header');
    var inner = document.querySelector('.js-drawer .drawer__inner');
    if (!header || !inner) return;

    function fit() {
      inner.style.top = header.offsetHeight + 8 + 'px';
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(fit).observe(header);
    }
    window.addEventListener('resize', fit);
    fit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===== Tarjetas de producto: carrusel en móvil + circulitos de variantes ===== */
(function () {
  var isTouch = window.matchMedia('(hover: none)').matches;

  function findCard(el) {
    var card = el.previousElementSibling;
    while (card && !(card.classList && card.classList.contains('product-card'))) {
      card = card.previousElementSibling;
    }
    return card;
  }

  /* Carrusel de fotos en móvil para las tarjetas del tema (colecciones, Best Sellers…) */
  function buildSliders(root) {
    if (!isTouch) return;
    (root || document).querySelectorAll('.nk-slides:not([data-nk-done])').forEach(function (data) {
      data.setAttribute('data-nk-done', '1');
      var card = findCard(data);
      if (!card) return;
      /* Solo se salta si la tarjeta está dentro de un deslizador que funciona de verdad */
      if (card.closest('.slick-initialized, .slick-track')) return;
      var wrap = card.querySelector('.product-card__image-wrapper');
      var spans = data.querySelectorAll('span[data-src]');
      if (!wrap || spans.length < 2) return;

      var url = data.getAttribute('data-url');
      var track = document.createElement('div');
      track.className = 'nk-track';
      spans.forEach(function (s) {
        var a = document.createElement('a');
        a.href = url;
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.src = s.getAttribute('data-src');
        img.srcset = s.getAttribute('data-srcset');
        img.sizes = '50vw';
        img.alt = s.getAttribute('data-alt') || '';
        a.appendChild(img);
        track.appendChild(a);
      });

      var bar = document.createElement('div');
      bar.className = 'nk-bar';
      var thumb = document.createElement('i');
      thumb.style.width = (100 / spans.length) + '%';
      bar.appendChild(thumb);

      wrap.classList.add('nk-has-track');
      wrap.appendChild(track);
      wrap.appendChild(bar);
    });
  }

  /* La línea de abajo avanza al deslizar (vale para colecciones y home) */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('nk-track')) return;
    var thumb = t.parentElement && t.parentElement.querySelector('.nk-bar i');
    if (thumb) thumb.style.transform = 'translateX(' + (t.scrollLeft / t.clientWidth * 100) + '%)';
  }, true);

  /* Mete los circulitos dentro de la tarjeta, al lado del nombre y el precio */
  function placeSwatches(root) {
    (root || document).querySelectorAll('.nk-card-sw:not([data-nk-moved])').forEach(function (sw) {
      sw.setAttribute('data-nk-moved', '1');
      var card = findCard(sw);
      if (!card) return;
      var content = card.querySelector('.product-card__content');
      if (!content) return;
      content.appendChild(sw);
      content.classList.add('nk-has-sw');
    });
  }

  function run() {
    buildSliders();
    placeSwatches();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Para los productos que se cargan al hacer scroll o con "Cargar más" */
  if ('MutationObserver' in window) {
    new MutationObserver(function () { run(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Al tocar un circulito: cambia la foto y el enlace de la tarjeta */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.nk-dot');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();

    var wrap = dot.closest('.nk-card-sw');
    var card = dot.closest('.product-card, .nkoda-tabs__card') || findCard(wrap);
    if (!card) return;

    wrap.querySelectorAll('.nk-dot').forEach(function (d) {
      d.classList.toggle('is-active', d === dot);
    });

    if (dot.dataset.src) {
      /* Foto principal */
      var img = card.querySelector('.product-card__img-visible, .nk-card-img') || card.querySelector('img');
      if (img) {
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-src');
        img.srcset = dot.dataset.srcset;
        img.src = dot.dataset.src;
      }
      /* Carrusel (móvil): cambia la primera foto y vuelve a ella */
      var track = card.querySelector('.nk-track');
      if (track) {
        var first = track.querySelector('img');
        if (first) {
          first.srcset = dot.dataset.srcset;
          first.src = dot.dataset.src;
        }
        track.scrollTo({ left: 0, behavior: 'smooth' });
      }
    }
    if (dot.dataset.url) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.setAttribute('href', dot.dataset.url);
      });
    }
  }, true);
})();
/* ===== Carrito: aplicar código de descuento sin ir al checkout ===== */
(function () {
  var EN = /^en/i.test((window.Shopify && Shopify.locale) || document.documentElement.lang || '');
  var T = EN ? {
    label: 'Discount', ph: 'Discount code', apply: 'Apply',
    bad: "Code {c} isn't valid for this order",
    remove: 'Remove code', err: 'Something went wrong. Please try again.'
  } : {
    label: 'Descuento', ph: 'Código de descuento', apply: 'Aplicar',
    bad: 'El código {c} no es válido para este pedido',
    remove: 'Quitar código', err: 'No se ha podido aplicar. Inténtalo de nuevo.'
  };
  var isOpen = false;
  var lastError = '';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function updateDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) {
      if (!r.ok) throw new Error('discount');
      return r.json();
    });
  }

  function reloadCart() {
    if (window.ajaxCart && typeof ajaxCart.load === 'function') ajaxCart.load();
  }

  function setOpen(box, open) {
    box.classList.toggle('is-open', open);
    var t = box.querySelector('[data-nk-dc-toggle]');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* Código aplicado = etiqueta pequeña en la línea del título */
  function showState(box) {
    var applied = box.querySelector('.nk-dc__applied');
    var msg = box.querySelector('.nk-dc__msg');
    msg.textContent = lastError;
    if (lastError) { isOpen = true; setOpen(box, true); }
    getCart().then(function (cart) {
      var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
      applied.innerHTML = codes.map(function (d) {
        return '<span class="nk-dc__chip">' + esc(d.code) +
          '<button type="button" class="nk-dc__remove" data-nk-dc-remove aria-label="' + T.remove + '">&times;</button></span>';
      }).join('');
    }).catch(function () {});
  }

  function setup(box) {
    box.setAttribute('data-nk-dc-ready', '1');
    var label = box.querySelector('[data-nk-dc-label]');
    if (label) label.textContent = T.label;
    var input = box.querySelector('.nk-dc__input');
    input.placeholder = T.ph;
    input.setAttribute('aria-label', T.ph);
    box.querySelector('[data-nk-dc-apply]').textContent = T.apply;
    if (!box.querySelector('.nk-dc__applied')) {
      var applied = document.createElement('div');
      applied.className = 'nk-dc__applied';
      box.insertBefore(applied, box.querySelector('.nk-dc__panel'));
    }
    setOpen(box, isOpen);
    showState(box);
  }

  function setupAll() {
    document.querySelectorAll('[data-nk-dc]:not([data-nk-dc-ready])').forEach(setup);
  }

  function apply(box) {
    var input = box.querySelector('.nk-dc__input');
    var btn = box.querySelector('[data-nk-dc-apply]');
    var code = input.value.trim();
    if (!code) { input.focus(); return; }
    btn.disabled = true;
    if (document.activeElement) document.activeElement.blur(); /* cierra el teclado del móvil */

    var previous = [];
    getCart()
      .then(function (cart) {
        previous = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        return updateDiscount(code);
      })
      .then(function (cart) {
        var mine = (cart.discount_codes || []).filter(function (d) {
          return d.code.toLowerCase() === code.toLowerCase();
        })[0];
        if (mine && mine.applicable) {
          lastError = '';
          isOpen = false;
          reloadCart();
          return;
        }
        /* No vale: se recupera el código que ya funcionaba y se avisa */
        lastError = T.bad.replace('{c}', code.toUpperCase());
        isOpen = true;
        return updateDiscount(previous.join(',')).then(reloadCart);
      })
      .catch(function () {
        /* Plan B: método clásico de Shopify */
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      })
      .finally(function () { btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest && e.target.closest('[data-nk-dc-remove]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var b = removeBtn.closest('[data-nk-dc]');
      updateDiscount('')
        .then(function () {
          b.querySelector('.nk-dc__applied').innerHTML = '';
          lastError = '';
          isOpen = false;
          reloadCart();
        })
        .catch(function () { b.querySelector('.nk-dc__msg').textContent = T.err; });
      return;
    }
    var toggle = e.target.closest && e.target.closest('[data-nk-dc-toggle]');
    if (toggle) {
      e.preventDefault();
      var box = toggle.closest('[data-nk-dc]');
      isOpen = !box.classList.contains('is-open');
      if (!isOpen) { lastError = ''; box.querySelector('.nk-dc__msg').textContent = ''; }
      setOpen(box, isOpen);
      if (isOpen) box.querySelector('.nk-dc__input').focus();
      return;
    }
    var applyBtn = e.target.closest && e.target.closest('[data-nk-dc-apply]');
    if (applyBtn) {
      e.preventDefault();
      apply(applyBtn.closest('[data-nk-dc]'));
    }
  });

  /* Enter en la casilla aplica el código (y no envía el carrito al checkout) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('.nk-dc__input');
    if (!input) return;
    e.preventDefault();
    apply(input.closest('[data-nk-dc]'));
  });

  /* El carrito se vuelve a dibujar cada vez que cambia: preparar la casilla nueva */
  if ('MutationObserver' in window) {
    new MutationObserver(setupAll).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }
})();
/* ===== Ficha de producto: zoom de fotos a tamaño real ===== */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var MAX = 2048, dims = {};

  /* Tamaño real de cada foto del producto */
  fetch(location.pathname.replace(/\/$/, '') + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) {
      (p.media || []).forEach(function (m) {
        var w = m.width || (m.preview_image && m.preview_image.width);
        var h = m.height || (m.preview_image && m.preview_image.height);
        if (w && h) dims[String(m.id)] = { w: w, h: h };
      });
    }).catch(function () {});

  function bigSrc(src, w) {
    if (!src) return src;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    src = src.replace(/_\d+x\d+(?=\.\w+(\?|$))/, '');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  document.addEventListener('click', function (e) {
    var wrap = e.target.closest('.product-single .product-media__wrapper--image');
    if (!wrap || typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') return;
    var group = wrap.closest('.js-product-media-group') || wrap.closest('.product-single');
    var pswpEl = document.querySelector('.pswp');
    if (!group || !pswpEl) return;
    e.preventDefault();
    e.stopPropagation();

    var imgs = [].slice.call(group.querySelectorAll('.js-product-media-item:not(.slick-cloned) img.mfp-image'));
    var clicked = wrap.querySelector('img.mfp-image');
    var clickedId = clicked && clicked.getAttribute('data-media-id');
    var index = 0;
    var items = imgs.map(function (img, i) {
      var id = img.getAttribute('data-media-id');
      if (id === clickedId) index = i;
      var d = dims[id];
      var w = d ? Math.min(d.w, MAX) : (img.naturalWidth || 1080);
      var h = d ? Math.round(w * d.h / d.w) : (img.naturalHeight || w);
      return { src: bigSrc(img.getAttribute('src') || img.getAttribute('data-src'), w), w: w, h: h };
    });

    new PhotoSwipe(pswpEl, PhotoSwipeUI_Default, items, {
      index: index, closeOnScroll: false, history: false, shareEl: false
    }).init();
  }, true);
})();